import { Line } from 'rc-progress'
import { MdOutlinePause } from "react-icons/md";
import { BsPlayFill } from "react-icons/bs";
import React, { useState } from 'react'
import { useRef } from 'react';
import { useEffect } from 'react';

export default function Audio({ src }) {
    const [isPlaying, setIsPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const audioRef = useRef();

    useEffect(() => {
        palyPause();
        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [audioRef?.current,isPlaying])

    const palyPause = () => {
        if (isPlaying) {
            audioRef?.current?.play();
        }else{
            audioRef?.current?.pause();
        }
    }

    const onPlaying = () => {
        const currentTime = audioRef.current.currentTime;
        const duration = audioRef.current.duration;
        const p = currentTime / duration * 100;
        setProgress(p)
    }
  return (
      <div className=" border border-gray-400 flex py-2 px-3 items-center rounded-xl">
          <div className="w-[180px] pt-2">
              <Line percent={0} strokeWidth={1} trailWidth={1} strokeColor="#0086E6" />
              <p className="text-primary text-xs pt-1">{audioRef?.current?.duration - progress || '0:00'}</p>
          </div>
          <div onClick={() => setIsPlaying(prev => !prev)} className="p-[5px] rounded-full text-primary border-2 border-primary text-2xl ml-3 cursor-pointer">
              {!isPlaying ? <BsPlayFill /> : <MdOutlinePause />}
          </div>

          <audio src={src} className="opacity-0 absolute -z-10" ref={audioRef} onTimeUpdate={onPlaying} preload="metadata" />
      </div>
  )
}
